// Avatar initials for a publisher — shared by the list cell and the page header.
export const initialsOf = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
